import { Component, DestroyRef, OnInit, inject, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { distinctUntilChanged } from 'rxjs/operators';
import { CookiesService } from 'src/app/services/cookies.service';
import { EntiteDropdownModel } from '../../../models/entites/entite-dropdown.model';
import { EntitesService } from '../../../services/entites/entites.service';

@Component({
  selector: 'app-entites-dropdownlist',
  templateUrl: './entites-dropdownlist.component.html',
  styleUrls: ['./entites-dropdownlist.component.scss'],
})
export class EntitesDropdownlistComponent implements OnInit {
  public entites = signal<Array<EntiteDropdownModel>>([]);
  public idEntiteSelected = signal<number>(0);
  private destroyRef = inject(DestroyRef);

  constructor(
    private entitesService: EntitesService,
    private cookieService: CookiesService
  ) {}

  get hasMoreThanOneEntites(): boolean {
    return this.entites() && this.entites().length > 1;
  }

  ngOnInit() {
    this.entitesService
      .getUtilisateursEntitesGerables()
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        distinctUntilChanged((prev, curr) => JSON.stringify(prev) === JSON.stringify(curr)),
      ).subscribe({
        next: (data) => {
          const filtered = data.filter(entite => entite.isEntiteTravail && entite.active);
          this.entites.set(filtered);
          const selectedId = this.selectEntite(filtered);
          this.idEntiteSelected.set(selectedId);
        },
      });
  }

  public selectEntite(data: Array<EntiteDropdownModel>) {
    let idEntite: number;
    if(document.cookie.includes('entiteSelected')) {
      let cookie = JSON.parse(this.cookieService.getCookie('entiteSelected')).entite;
      this.entitesService.setIdEntiteSelected(cookie);
      idEntite = cookie;
    } else {
      idEntite = data[0].id;
      this.entitesService.setIdEntiteSelected(idEntite);
    }
    return idEntite;
  }

  onEntiteChange(event: any) {
    const selectElement = event.target as HTMLSelectElement;
    const newId = Number(selectElement.value);
    this.idEntiteSelected.set(newId);
    this.entitesService.setIdEntiteSelected(newId);
    this.cookieService.setCookie('entiteSelected', {entite: newId});
  }
}
